import {
  CustomerRegisterInterface,
  GranularityType,
  granularityTranslator,
} from '@/core/domain/people/Customers/Customers.types';
import { useChartTheme } from '@/hooks';
import { ResponsiveLine } from '@nivo/line';
import { Card, Typography } from 'antd';
import moment from 'moment';

interface Props {
  baseColor: string[];
  granularity?: GranularityType;
  customerRegister?: CustomerRegisterInterface[];
}

export default function CustomerStatisticIndicatorsChart({
  baseColor,
  granularity,
  customerRegister,
}: Props) {
  const [maleColor, femaleColor, unspecifiedColor, totalColor] = baseColor;

  const chartTheme = useChartTheme();

  const formattedData = [
    {
      id: 'Masculino',
      color: maleColor,
      data:
        customerRegister?.map((item) => ({
          x: moment(item.date).format('DD-MM-YYYY'),
          y: item.male,
        })) || [],
    },
    {
      id: 'Feminino',
      color: femaleColor,
      data:
        customerRegister?.map((item) => ({
          x: moment(item.date).format('DD-MM-YYYY'),
          y: item.female,
        })) || [],
    },
    {
      id: 'Não definido',
      color: unspecifiedColor,
      data:
        customerRegister?.map((item) => ({
          x: moment(item.date).format('DD-MM-YYYY'),
          y: item.total - item.female - item.male,
        })) || [],
    },
    {
      id: 'Total',
      color: totalColor,
      data:
        customerRegister?.map((item) => ({
          x: moment(item.date).format('DD-MM-YYYY'),
          y: item.total,
        })) || [],
    },
  ];

  return (
    <Card style={{ borderRadius: 4, padding: 20 }}>
      <Typography.Title level={4} style={{ textAlign: 'center' }}>
        {`Clientes por Período  ${
          granularity ? 'de ' + granularityTranslator[granularity] : ''
        }`}
      </Typography.Title>
      <div style={{ height: 300 }}>
        <ResponsiveLine
          data={formattedData ? formattedData : []}
          enableSlices="x"
          margin={{ top: 15, right: 25, bottom: 90, left: 70 }}
          xScale={{ type: 'point' }}
          yScale={{
            type: 'linear',
            min: 0,
            max: 'auto',
            reverse: false,
          }}
          curve="monotoneX"
          axisTop={null}
          axisRight={null}
          axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legendOffset: 36,
            legend: granularity
              ? `Período em ${granularityTranslator[granularity]}`
              : undefined,
            legendPosition: 'middle',
          }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            tickValues: 5,
            legend: 'Quantidade',
            legendOffset: -50,
            legendPosition: 'middle',
          }}
          enableGridX={false}
          pointColor={{ theme: 'background' }}
          pointBorderWidth={2}
          pointBorderColor={{ from: 'serieColor' }}
          pointLabelYOffset={-12}
          useMesh
          theme={chartTheme}
          legends={[
            {
              anchor: 'bottom',
              direction: 'row',
              justify: false,
              translateX: 0,
              translateY: 80,
              itemWidth: 140,
              itemHeight: 20,
              itemsSpacing: 4,
              symbolSize: 20,
              symbolShape: 'circle',
              itemDirection: 'left-to-right',
              itemTextColor: '#777',
              effects: [
                {
                  on: 'hover',
                  style: {
                    itemBackground: 'rgba(0, 0, 0, .03)',
                    itemOpacity: 1,
                  },
                },
              ],
            },
          ]}
        />
      </div>
    </Card>
  );
}
